import apiHandler from "../core/apiHandler";

/**
 * 🌐 QZ Tray Connection API
 *
 * Módulo base para las peticiones del monitor de conexión QZ Tray.
 *
 * ✅ Endpoints:
 * - /api/qztray/connection/ping
 * - /api/qztray/connection/status
 * - /api/qztray/connection/status/live
 * - /api/qztray/connection/reconnect
 * - /api/qztray/connection/version
 */
const qzTrayConnectionApi = apiHandler("qztray/connection");

export default qzTrayConnectionApi;
